import React from 'react'
import styled from 'styled-components'
import IconContract from 'assets/icons/contract.svg'
import IconNetwork from 'assets/icons/network-signal.svg'
import IconNotesLock from 'assets/icons/notes-lock.svg'

import { RFP_STATE } from '../constants'

const Icon = styled.img`
  width: 26px;
  height: 26px;
  margin-right: 10px;
`
const statesMap = {
  [RFP_STATE.PUBLISHED]: { label: 'Published', icon: IconNetwork },
  [RFP_STATE.CLOSED]: { label: 'Published', icon: IconNetwork },
  [RFP_STATE.DRAFT]: { label: 'Unpublished', icon: IconNotesLock },
  [RFP_STATE.FINALIZED]: { label: 'Finalized', icon: IconContract },
}

export default function RfpState({ state }: { state: string }) {
  const { icon, label } = statesMap[state]
  return (
    <>
      <Icon src={icon} alt={label} />
      {label}
    </>
  )
}
